
import { Store } from '@ngrx/store';
import { CognitoAuthService } from './cognito/congnito-auth-service'
import { AppSetting } from '../models/settings/casual-portal/app-setting';

import { AuthService } from './auth-service'
import { CDCAuthService } from './cdc/cdc-auth-service'
import { AzureCiamAuthService } from './azure/azure-ciam-auth-service';

export class AuthServiceFactory {


    static createAuthService(settings: AppSetting): AuthService | null {
        let _settings = (settings?.B2CIntegration?.B2CLoginProvider ?? '')
        switch (_settings) {
            case 'sap-cdc':
                return new CDCAuthService();
            case 'azure':
                return new AzureCiamAuthService();

            case 'cognito':
                return new CognitoAuthService();
            default:
                return null;
        }
    }

    static isB2CEnable(settings: AppSetting) {
        return (settings?.B2CIntegration?.B2CLoginProvider ?? '') != ''
    }
    static disableCompanyData(settings: AppSetting) {
        let _settings = (settings?.B2CIntegration?.B2CLoginProvider ?? '')
        return _settings == 'sap-cdc'
    }
    static disableAddress(settings: AppSetting) {
      let _settings = settings &&
      settings.B2CIntegration &&
      settings.B2CIntegration.B2CLoginProvider
        ? settings.B2CIntegration.B2CLoginProvider
        : '';

      let addressFields = [
        'address.address1',
        'address.city',
        'address.stateCode',
        'address.country',
        'address.postCode',
      ];

      let contactFieldMappings =
        settings &&
        settings.B2CIntegration &&
        settings.B2CIntegration.AzureB2CIntegration &&
        settings.B2CIntegration.AzureB2CIntegration.ContactFieldMappings
          ? settings.B2CIntegration.AzureB2CIntegration.ContactFieldMappings
          : [];

      let isAddressMapped = contactFieldMappings.some(mapping =>
        addressFields.includes(mapping.MappedTo)
      );

      return _settings == 'azure' ? isAddressMapped : _settings == 'sap-cdc';
    }

  static isAzure(settings: AppSetting) {
    let _settings = settings &&
    settings.B2CIntegration &&
    settings.B2CIntegration.B2CLoginProvider
      ? settings.B2CIntegration.B2CLoginProvider
      : '';

    return _settings == 'azure'
  }
  static isCDC(settings: AppSetting) {
    let _settings = settings &&
    settings.B2CIntegration &&
    settings.B2CIntegration.B2CLoginProvider
      ? settings.B2CIntegration.B2CLoginProvider
      : '';

    return _settings == 'sap-cdc'
  }
}
